module.exports = __webpack_public_path__ + "static/media/crwn-shop.ad85969c.png";